'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo from "./app.data.-App-Document-Organization-Info.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationInfo$$anon$1() {
}
export { $c_Lapp_data_OrganizationInfo$$anon$1 as $c_Lapp_data_OrganizationInfo$$anon$1 };
$p = $c_Lapp_data_OrganizationInfo$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationInfo$$anon$1;
/** @constructor */
function $h_Lapp_data_OrganizationInfo$$anon$1() {
}
export { $h_Lapp_data_OrganizationInfo$$anon$1 as $h_Lapp_data_OrganizationInfo$$anon$1 };
$h_Lapp_data_OrganizationInfo$$anon$1.prototype = $p;
$p.bwQ = (function(src) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo.$c_Lapp_data_AppDocumentOrganizationInfo(src.BF, src.LK, src.LL);
});
$p.ak = (function(src) {
  return this.bwQ(src);
});
var $d_Lapp_data_OrganizationInfo$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationInfo$$anon$1, "app.data.OrganizationInfo$$anon$1", ({
  Ej: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_OrganizationInfo$$anon$1 as $d_Lapp_data_OrganizationInfo$$anon$1 };
//# sourceMappingURL=app.data.-Organization-Info$$anon$1.js.map
